export const slugify = (str?: string) => {
  if (!str) return str;
  const decodedString = decodeURIComponent(str);
  return decodedString.replace(/\s/g, '-');
};

export const deslugify = (str: string) => {
  return str.replace(/-/g, ' ');
};
